import type * as React from 'react';

import { styled } from 'styled-components';

import { typographyCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';

import { getName } from 'common/utils/reportUtils';

type Props = {
  name?: string;
  phone?: string;
};

const Root = styled.div`
  ${typographyCss.Body3({ weight: 'semiBold' })};
  display: flex;
  flex-direction: column;
`;

const Phone = styled.div`
  ${typographyCss.Body3()};
  color: ${color.textSubdued};
`;

const Name: React.FC<Props> = ({ name, phone }) => {
  return (
    <Root title="Name">
      <div>{getName(name)}</div>
      {phone ? <Phone>{phone}</Phone> : null}
    </Root>
  );
};

export default Name;
